<script setup lang="ts">
import ReviewButton from './components/ReviewButton.vue'
// 根组件 - 只负责路由和全局布局
</script>

<template>
  <div id="app">
    <!-- 全局复习按钮（所有页面共享） -->
    <ReviewButton />
    
    <!-- 路由视图 - 渲染子页面 -->
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>

<style scoped>
/* 路由切换动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>